import React, { useId } from "react";
import SettingModalRedButton from "../SettingModalRedButton/SettingModalRedButton";
import { Observer } from "mobx-react-lite";
import ProfileStore2 from "../../store/ProfileStore2";
import { clickableButton } from "../../utils/constants";

const UnlockAccModal = ({
  onClose,
  modalConfig,
  img,
  step,
  setStep,
  setLastTableAction,
}) => {
  const id1 = useId();

  const toggle = () => {
    if (step) {
      onClose();
      return;
    }
    ProfileStore2.unlockAccount(modalConfig.client, {
      onSuccess: () => {
        setLastTableAction();
        setStep(step + 1);
      },
    });
  };

  return (
    <Observer>
      {() => {
        return (
          <div id={id1} className="unlock_acct_modal">
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "10px",
              }}
            >
              {img}
            </div>
            <h2>
              {!step
                ? `Unlock ${modalConfig?.client?.full_name}'s account`
                : `${modalConfig?.client?.full_name}'s account has been unlocked`}
            </h2>
            <p>
              {!step
                ? "Are you sure you want to unlock the selected account?"
                : "This account has been successfully unlocked!"}
            </p>
            <div
              className="btn_div"
              style={{
                justifyContent: !step ? "space-between" : "flex-end",
              }}
            >
              {!step && (
                <button
                  className="cancel"
                  style={clickableButton}
                  onClick={onClose}
                >
                  Cancel
                </button>
              )}
              <SettingModalRedButton
                label={!step ? "Yes, Unlock" : "Got it"}
                btnClass={step || "step0"}
                toggle={() => toggle()}
              />
            </div>
          </div>
        );
      }}
    </Observer>
  );
};

export default UnlockAccModal;
